import React, {ReactElement} from "react";

import Icon from "../../icon/Icon";
import CTAButton, {CTA} from "../../buttons/cta-button/CTAButton";

import CloseIcon from "/src/svg/close.svg";

import {css} from "/src/utils/utils";
import translate from "/src/utils/translate";

import * as styles from "./promo-banner.module.scss";

interface PromoBannerProps {
  cta: CTA;
  handleClose: () => void;
  title?: string;
}

const PromoBanner = (props: PromoBannerProps): ReactElement => {
  const {cta, handleClose, title} = props;

  return (
    <div role="banner" className={styles.promoBanner}>
      <button
        type="button"
        onClick={handleClose}
        aria-label={translate("close")}
        className={styles.promoBanner__closeBtn}
      >
        <Icon
          svg={CloseIcon}
          role="presentation"
          classes={styles.promoBanner__closeBtn__icon}
        />
      </button>
      <div className={styles.promoBanner__content}>
        <p className={css("h6", styles.promoBanner__content__body)}>{title}</p>
        {cta && <CTAButton cta={cta} kind="secondary" />}
      </div>
    </div>
  );
};

export default PromoBanner;
